
















































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { OsusumeSeibiService } from "@/services/OsusumeSeibi.service.ts";
import Number from "@/shared/filters/Number";
import { OsusumeSeibiItem } from "@/models/OsusumeSeibi";
import InputNumber from "@/views/components/input/InputNumber.vue";
import InputString from "@/views/components/input/InputString.vue";
import vuedraggable from "vuedraggable";
import { CommonService } from "@/services/Common.service";
import { AccountService } from "@/services/account.service.ts";

@Component({
  filters: {
    Number
  },
  components: {
    InputNumber,
    InputString,
    draggable: vuedraggable
  }
})
export default class OsusumeSeibi extends Vue {
  @Prop({ default: "" })
  title: string;
  public accountService = new AccountService();
  public osusumeSeibiService = new OsusumeSeibiService();
  public groupDataList: any = [];
  public shatenDataList: any = [];
  public kyotenDataList: any = [];
  selectedTaxRate: number | null = null;
  public commonService = new CommonService();
  public itemAdd: OsusumeSeibiItem = {
    seibiNm: "",
    buhinZn: null,
    buhinZk: null,
    kouchinZn: null,
    kouchinZk: null
  };
  public itemEdit: OsusumeSeibiItem = {
    id: 0,
    seibiNm: "",
    buhinZn: null,
    buhinZk: null,
    kouchinZn: null,
    kouchinZk: null
  };
  public seibiList: OsusumeSeibiItem[] = [];

  public form: any = {
    kyotenCd: "",
    groupCd: "",
    shatenCd: ""
  };
  private loading: boolean = true;
  public dialogFormVisible: boolean = false;
  disableBtnAdd: boolean = true;
  disableBtnEdit: boolean = true;
  timerReOrder: any = null;
  taxList: any = [];

  shouhizeiMarumeKbn: number = 0;
  environment: any;

  public delay(time: number) {
    setTimeout(() => {
      this.loading = false;
    }, time);
  }

  public async getTaxList() {
    const response = await this.commonService.getTaxList();
    if (response) {
      this.$set(this, "taxList", response);
      const tempTax: any = this.taxList.filter((data: any) => data.isCurrent == 1);
      if (tempTax.length !== 0) {
        this.selectedTaxRate = tempTax[0].rateExtremeType;
      }
    }
  }

  public async addItem() {
    this.loading = true;
    this.osusumeSeibiService.addOsusumeSeibi(this.itemAdd).then((response: any) => {
      this.getOsusumeSeibi();
    });
  }

  public async editItem() {
    this.loading = true;
    this.osusumeSeibiService.editOsusumeSeibi(this.itemEdit).then((response: any) => {
      this.dialogFormVisible = false;
      this.getOsusumeSeibi();
    });
  }

  public async delItem(item: OsusumeSeibiItem) {
    this.loading = true;
    this.osusumeSeibiService.deleteOsusumeSeibi(item).then((response: any) => {
      this.getOsusumeSeibi();
    });
  }

  public showEditDialog(rowData: OsusumeSeibiItem) {
    this.dialogFormVisible = true;
    this.itemEdit = { ...rowData };
    this.focusOutZn(true, "");
  }

  private mounted() {
    this.getTaxList();
    this.getMarumeKbn();

    this.form.kyotenCd = localStorage.getItem("kyotenCd");

    this.getGroupDataList().then(res => {
      this.getOsusumeSeibi();
    });
  }

  public async getGroupDataList() {
    const response = await this.accountService.getGroups();
    if (response && response.data) {
      this.$set(this, "groupDataList", response.data);
      this.form.groupCd = response.groupCd || "";
      this.form.shatenCd = response.shatenCd || "";
    }
    return response;
  }

  async getOsusumeSeibi() {
    this.loading = true;
    this.osusumeSeibiService.getOsusumeSeibi().then((response: OsusumeSeibiItem[]) => {
      if (response) {
        this.seibiList = response;
      } else {
        this.seibiList = [];
      }
      this.loading = false;
    });
  }

  async getMarumeKbn() {
    this.environment = await this.commonService.getEnvironment();
    if (this.environment) {
      this.shouhizeiMarumeKbn = this.environment.shouhizeiMarumeKbn;
    }
  }

  focusOutZn(isEdit: boolean, key: string = "") {
    this.focusOutPrice(isEdit, false, key);
  }

  focusOutZk(isEdit: boolean, key: string = "") {
    this.focusOutPrice(isEdit, true, key);
  }

  async focusOutPrice(isEdit: boolean, isZk: boolean, key: string = "") {
    let item: any = this.getItemData(isEdit);
    if (isEdit) {
      this.checkDisabledEdit();
    } else {
      this.checkDisabledAdd();
    }
    if (isZk) {
      if (item.buhinZk && (key == "buhin" || key == "")) {
        let zn = await this.commonService.calcZeinuki(item.buhinZk, this.selectedTaxRate, this.shouhizeiMarumeKbn);
        this.$set(item, "buhinZn", zn);
      }
      if (item.kouchinZk && (key == "kouchin" || key == "")) {
        let zn = await this.commonService.calcZeinuki(item.kouchinZk, this.selectedTaxRate, this.shouhizeiMarumeKbn);
        this.$set(item, "kouchinZn", zn);
      }
    } else {
      if (item.buhinZn && (key == "buhin" || key == "")) {
        let zk = await this.commonService.calcZeikomi(item.buhinZn, this.selectedTaxRate, this.shouhizeiMarumeKbn);
        this.$set(item, "buhinZk", zk);
      }
      if (item.kouchinZn && (key == "kouchin" || key == "")) {
        let zk = await this.commonService.calcZeikomi(item.kouchinZn, this.selectedTaxRate, this.shouhizeiMarumeKbn);
        this.$set(item, "kouchinZk", zk);
      }
    }
  }

  getItemData(isEdit: boolean) {
    let item: any;
    if (isEdit) {
      item = this.itemEdit;
    } else {
      item = this.itemAdd;
    }
    return item;
  }

  checkDisabledAdd() {
    let disabled = false;
    if (this.itemAdd.seibiNm === "" || this.itemAdd.buhinZn == null || this.itemAdd.kouchinZn == null) {
      disabled = true;
    }
    this.$set(this, "disableBtnAdd", disabled);
  }

  checkDisabledEdit() {
    let disabled = false;
    if (this.itemEdit.seibiNm === "" || this.itemEdit.buhinZn == null || this.itemEdit.kouchinZn == null) {
      disabled = true;
    }
    this.$set(this, "disableBtnEdit", disabled);
  }

  onEnd(event: any) {
    console.log("onEnd -> event", this.seibiList);
    if (this.timerReOrder) {
      clearTimeout(this.timerReOrder);
      this.timerReOrder = null;
    }
    this.timerReOrder = setTimeout(() => {
      this.osusumeSeibiService.reorderOsusumeSeibi(this.seibiList).then((response: any) => {
        this.getOsusumeSeibi();
      });
    }, 1000);
  }

  clearInput() {
    this.itemAdd.seibiNm = "";
    this.itemAdd.buhinZk = null;
    this.itemAdd.buhinZn = null;
    this.itemAdd.kouchinZk = null;
    this.itemAdd.kouchinZn = null;
    this.checkDisabledAdd();
  }

  async onChangeTaxRate() {
    if (this.itemAdd.buhinZn) {
      let zk = await this.commonService.calcZeikomi(this.itemAdd.buhinZn, this.selectedTaxRate);
      this.$set(this.itemAdd, "buhinZk", zk);
    }
    if (this.itemAdd.kouchinZn) {
      let zk = await this.commonService.calcZeikomi(this.itemAdd.kouchinZn, this.selectedTaxRate);
      this.$set(this.itemAdd, "kouchinZk", zk);
    }
  }
}
